"use strict";

;
;

(function ($) {
  var callbacks = $.Callbacks();
  callbacks.add(init);
  callbacks.fire();
  /**
   * 初始化的函数
   */

  function init() {
    // getSearchKeywords();
    getSearchKeyHotKeywords(); // 二级菜单鼠标划入发送的ajax的函数

    navHoverAjax();
    clickSearch();
    locationTop();
    checkLogin();
    logout();
  }
  /**
  * nav二级菜单hover发送ajax的函数
  */


  function navHoverAjax() {
    var hover_two_get_staring = false; // 鼠标hover上去的时候采取发送请求

    $(".nav-list").mouseover(function () {
      // 函数节流
      if (!hover_two_get_staring) {
        setTimeout(function () {
          getTwoCategory().then(function (data) {
            // 返回的信息未success代表成功
            if (data.msg === "success") {
              hover_two_get_staring = true;
              var tabs = data.data.data.tabs;
              var tabs_html = "";

              for (var i = 0; i < tabs.length; i++) {
                tabs_html += "<li class=\"t-w-m-item\"><span data-categoryId=\"".concat(tabs[i].categoryId, "\">").concat(tabs[i].name, "</span>\n                                <div class=\"t-w-box\">\n\n                                </div>\n                                </li>");
              } // 拼接数据


              $(".t-w-menu").html(tabs_html);
              threeCategoryAjax();
            }
          });
        }, 100);
      }
    });
  } // 点击top直接返回页面最上面


  function locationTop() {
    $(".location-top,.top_txt").click(function () {
      $(window).scrollTop(0);
    });
  }
  /**
  * 点击出现搜索历史框和推荐商品
  */


  function clickSearch() {
    $(".search-ipt").click(function () {
      $(".search-helper").show();
    });
    $(".search-ipt").blur(function () {
      $(".search-helper").hide();
    });
  } // 获取搜索关键字


  function getSearchKeywords() {
    $.ajax({
      url: "https://mapi.vip.com/vips-mobile/rest/shopping/search/entryword/pc/v1",
      dataType: "jsonp",
      data: {
        app_name: "shop_pc",
        app_version: 4.0,
        warehouse: "VIP_SH",
        fdc_area_id: "103104110",
        client: "pc",
        mobile_platform: 1,
        province_id: 103104,
        api_key: "70f71280d5d547b2a7bb370a529aeea1",
        user_id: "",
        mars_cid: "1585923048293_a96d442f0be377ab63fc1790f5d32873",
        wap_consumer: "a",
        channel_id: 1,
        gPlatform: "PC",
        _: Date.now()
      },
      success: function success(data) {
        // 数据请求成功之后需要将数据渲染到页面之中
        if (data.msg === "success") {
          $(".search-ipt").attr("placeholder", data.data.showWord);
        }
      },
      jsonpCallback: "getSearchwords"
    });
  } // 获取搜索热点关键字


  function getSearchKeyHotKeywords() {
    $.ajax({
      url: "https://category.vip.com/ajax/getSuggestHotKeywords.php",
      dataType: "jsonp",
      data: {
        count: 10,
        uid: "",
        _: Date.now()
      },
      success: function success(data) {
        // code为200代表返回的是成功状态
        var hot_list_html = "";
        var search_recommend_list_html = "";

        if (data.code === 200) {
          var res = data.data;

          for (var i = 0; i < res.length; i++) {
            search_recommend_list_html += "<li><a href=\"".concat(res[i].url, "\">").concat(res[i].key, "</a></li>");
          }

          for (var _i = 0; _i < res.length; _i++) {
            if (_i === 3) {
              hot_list_html += "<li><a href=\"".concat(res[_i].url, "\">").concat(res[_i].word, "</a></li>");
              break;
            }

            hot_list_html += "<li><a href=\"".concat(res[_i].url, "\">").concat(res[_i].word, "</a><span>|</span></li>");
          } // 替换到页面之中


          $(".search-hots-pot .hot-list").html(hot_list_html);
          $(".search-recommend-list ul").html(search_recommend_list_html);
        }
      },
      jsonpCallback: "searchSuggestHotKeywords"
    });
  } // 二级菜单的数据


  function getTwoCategory() {
    return $.ajax({
      url: "../json/TopCategory.json",
      dataType: "json"
      /*        data: {
                 app_name: "shop_pc",
                 app_version: 4.0,
                 warehouse: "VIP_SH",
                 fdc_area_id: "103104110",
                 client: "PC",
                 mobile_platform: 1,
                 province_id: 103104,
                 api_key: "70f71280d5d547b2a7bb370a529aeea1",
                 user_id: "",
                 mars_cid: "1585923048293_a96d442f0be377ab63fc1790f5d32873",
                 wap_consumer: "a",
                 hierarchy_id: 117,
                 _: Date.now()
             }, */

    });
  } // 三级菜单数据请求


  function getThreeCategory(args) {
    return $.ajax({
      url: "../json/SubCategory" + args.categoryId + ".json",
      dataType: "json"
      /*             data: {
                      app_name: "shop_pc",
                      app_version: 4.0,
                      warehouse: "VIP_SH",
                      fdc_area_id: "103104110",
                      client: "PC",
                      mobile_platform: 1,
                      province_id: "103104",
                      api_key: "70f71280d5d547b2a7bb370a529aeea1",
                      user_id: "",
                      mars_cid: "1585923048293_a96d442f0be377ab63fc1790f5d32873",
                      wap_consumer: "a",
                      hierarchyId: 117,
                      categoryId: args.categoryId,
                      clientFrom: "PC",
                      net: "wifi",
                      width: 1920,
                      height: 1080,
                      pcmpWidth: 750,
                      mobile_channel: "nature",
                      functions: "jumper",
                      _: Date.now()
                  }, */

    });
  } // 三级菜单的请求发送


  function threeCategoryAjax() {
    $(".t-w-m-item").mouseenter(function () {
      // 难道每一个二级菜单的category的ID值
      var category_id = this.firstElementChild.getAttribute("data-categoryId");
      getThreeCategory({
        categoryId: category_id
      }).then(function (data) {
        renderThreeCategory(data);
      });
    });
  } // 三级菜单数据渲染操作


  function renderThreeCategory(data) {
    // 三级菜单变量
    var sub_category_html = ""; // 三级菜单热门品牌图片变量

    var brand_rec = "";
    var res = data.data.data.sectionList; // 图片列表的变量

    var img_list = "";

    for (var i = 1; i < res.length; i++) {
      var list_html = "";
      var children = res[i].category.children;

      for (var j = 0; j < children.length; j++) {
        // 因为接口数据最后一项是热销商品的图片数据
        if (i === res.length - 1) {
          img_list += " <li class=\"b-img\"><a href=\"".concat(children[j].href, "\"><img\n                                    src=\"").concat(children[j].image, "\"></a></li>");
          continue;
        }

        list_html += "<li class=\"category_item\"><a href=\"".concat(children[j].href, "\">").concat(children[j].name, "</a></li>");
      }

      if (i === res.length - 1) {
        continue;
      } // 三级菜单循环渲染


      sub_category_html += "<div class=\"sub clearfix\">\n                            <strong>".concat(res[i].category.name, "</strong>\n                            <i class=\"iconfont icon-zuojiantou-copy\"></i>\n                            <ul class=\"category_list\">\n                            ").concat(list_html, "\n                            </ul>\n                            </div>");
    } // 最后处理三级菜单的html代码


    sub_category_html = "<div class=\"brand-type clearfix\">\n                            ".concat(sub_category_html, "\n                        </div>"); // 每一个品牌热销的图片html代码

    brand_rec += " <div class=\"brand-img\"><div class=\"brand-title\">\n                        \u54C1\u724C\u63A8\u8350\n                        </div>\n                        <ul class=\"brands\">\n                            ".concat(img_list, "\n                        </ul></div>"); // 渲染到页面之中

    $(".t-w-box").html(sub_category_html + brand_rec);
  }
  /**
   * 检查是否登录
   */


  function checkLogin() {
    var userInfo = $.cookie("userLoginInfo"); // 等于undefined直接结束

    if (userInfo === undefined) {
      return false;
    } // 不然我们需要将用户信息放在页面之中 表示已登录


    var user = JSON.parse(userInfo);
    $(".sign-text").html(user.username);
    $(".top-pic-infs").addClass("hidden").next().removeClass("hidden").find(".success_username").html(user.username);
    $("#my_cnt_no_name").addClass("hidden").next().removeClass("hidden").find("#my_cnt_user_name").html(user.username);
  }
  /**
   * 退出
   */


  function logout() {
    $(".top-pic-success").on("click", ".logout", function () {
      $.removeCookie("userLoginInfo");
      location.reload();
    });
  }
})(jQuery);